export default {
  name: 'GlobalStates',

  data () {
    return {
      globalSelectedStatusId: null
    }
  }
}
